import type { ImageProps } from './image.types';
import { path } from '@/utils/helper';

export default function Image(props: ImageProps) {
  return <img alt={props.src} src={path(`/images/article/${props.src}`)} />;
}
